
import React from "react";
import { MessageSquare } from "lucide-react";

const ActivityEmptyComponent: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-[200px] text-center">
      <MessageSquare className="h-8 w-8 text-white/70 mb-2" />
      <p className="text-white/70">No activity recorded just yet, let's change that!</p>
    </div>
  );
};

// Memoize since this is a static component with no props
export const ActivityEmpty = React.memo(ActivityEmptyComponent);
